import React from 'react';
import PropTypes from 'prop-types';
import Button02 from '../button/Button02';
import DataSellCoins from '../../assets/fake-data/dataSellCoins';
import { useTranslation } from 'react-i18next';



function About3() {
    const { t } = useTranslation();
    const data = DataSellCoins();
    return (
        <section className="tf-about-ss">
            <div className="icon">
                <svg width="264" height="426" viewBox="0 0 264 426" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_f_2268_552)">
                    <path d="M162.226 50.3816L109.596 154.133L220.194 117.978L241.73 183.858L131.132 220.012L234.883 272.642L203.529 334.452L99.7779 281.822L135.932 392.42L70.0528 413.956L33.8982 303.358L-18.7318 407.109L-80.541 375.755L-27.911 272.004L-138.509 308.158L-160.045 242.279L-49.4471 206.124L-153.198 153.494L-121.844 91.6849L-18.0931 144.315L-54.2477 33.7168L11.632 12.1807L47.7866 122.779L100.417 19.0276L162.226 50.3816Z" fill="url(#paint0_linear_2268_552)"/>
                    </g>
                    <defs>
                    <filter id="filter0_f_2268_552" x="-172.045" y="0.180664" width="426.775" height="426.775" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="6" result="effect1_foregroundBlur_2268_552"/>
                    </filter>
                    <linearGradient id="paint0_linear_2268_552" x1="-137.521" y1="122.589" x2="219.206" y2="303.547" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="var(--primary-color35)"/>
                    <stop offset="1" stopColor="var(--primary-color35)" stopOpacity="0"/>
                    </linearGradient>
                    </defs>
                </svg>
            </div>


            <div className="tf-container2 pb-3 mb-4">
                <div className="row">
                    <div className="col-md-12">
                        <div className="title-ss wow fadeInUp">
                            <h3>{t('sell_your_coins')}</h3>
                            
                        </div>
                    </div>

                    {
                        data.map(idx => (
                            <div key={idx.id} className="col-md-6 col-sm-6">
                                <div className="tf-step style2 wow fadeInUp">
                                    <div className="step-title">
                                        <div className="sub-number" style={{fontSize: '200px'}}>
                                            +
                                        </div>
                                        <h3>{t(idx.title)}</h3>
                                    </div>
                                    <p>{t(idx.text)}</p>
                                </div>
                            </div>
                        ))
                    }

                {/* <div className="col-md-12 wow fadeInUp">
                    <div className="btn">
                        <Button02 path='/sells' title={t('sell_your_coins')} />
                    </div>
                </div> */}
                </div>
            </div>

            <div className="tf-heading wow fadeInUp pt-3">
                                <h2 className="heading cooperate">{t('cooperate')}</h2>
                                <p className="sub-heading">{t('wearetocooperate')}</p>
                                <div className="tf-counter wow fadeInUp pt-2">
                                <h6 className="">{t('pseudoSkype')}:</h6>
                                <div className="content" style={{ fontSize: "30px" }}>
                                <div className="content" style={{ fontSize: "30px" }}>
    <span 
        className="counter-number" 
        style={{
            backgroundSize: "300% auto",
            color: "linear-gradient(90deg, #21E786, #1AC973, #0DB863, #1AC973, #21E786)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            animation: "text-gradient 3s ease infinite",
            fontWeight: "bold",
            display: "inline-block",
            textDecoration: "underline"
        }}
    >
        live:.cid.19a3b6bbca6cb2fc
    </span>
</div>

                                    
                                </div>
                            </div>
                            </div>
        </section>
    );
}

export default About3;